import React from 'react';
import { Box, Drawer, List, ListItem } from "@mui/material";
import NavLink from "./NavLink";
import FormSelect from "../FormSelect";
import { useI18n } from "../../../i8n/useI18n";
import { useLanguage } from "../../../hooks/LanguageProvider";

interface NavDrawerProps {
    open: boolean;
    toggle: () => void;
}

const NavDrawer = (props: NavDrawerProps) => {
    const { t } = useI18n();
    const { language, availableLanguages, handleLanguageChange } = useLanguage();

    return (
        <nav>
            <Drawer
                anchor="top"
                variant="temporary"
                open={props.open}
                onClose={props.toggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: 'block', lg: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: "100%" },
                }}
            >
                <Box onClick={props.toggle} sx={{ textAlign: 'center', bgcolor: "background.paper" }}>
                    <List sx={{ my: 6 }}>
                        {[
                            { name: t("nav.shop"), href: t("links.shop") },
                            { name: t("nav.journal"), href: t("links.blog") },
                            { name: t("nav.contact"), href: t("links.contact") },
                        ].map((item) => (
                            <ListItem key={item.name} sx={{ justifyContent: "center" }}>
                                <Box sx={{ margin: "10px auto" }}>
                                    <NavLink name={item.name} href={item.href} />
                                </Box>
                            </ListItem>
                        ))}
                        <ListItem sx={{ justifyContent: "center", mt: 2 }} onClick={(e) => e.stopPropagation()}>
                            <FormSelect
                                label="Language"
                                value={language}
                                items={availableLanguages}
                                onChange={handleLanguageChange}
                                sx={{ width: 90 }}
                            />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </nav>
    );
};

export default NavDrawer;
